import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyStudyCriteriaApiService } from './company-study-criteria-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyStudyCriteriaApiService extends GeneratedCompanyStudyCriteriaApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
